import { parsePhoneNumberWithError } from 'libphonenumber-js';

export const isValidPhoneNumber = (val: string): boolean => {
  try {
    const phoneNumber = parsePhoneNumberWithError(val, {
      defaultCountry: 'DE',
      extract: false,
    });

    if (phoneNumber.country !== 'DE') {
      return false;
    }

    return phoneNumber.isValid();
  } catch {
    return false;
  }
};
